import React from "react";
import NumberInput from "../../../../../common/NumberInput";
import Indicator from "../../Indicator";
import { compose } from "redux";
import { withTranslation } from "react-i18next";

class DecimalPositif extends React.Component {
  render() {
    const {
      t,
      indicateur,
      onChangeIndicator,
      sousRubriqueIndex,
      libelleEnglobantIndex,
      changeIndicateur,
      valueInputProps,
      computedFields,
      demarche,
    } = this.props;

    const valeurCalculee = (
      <NumberInput
        fullWidth={false}
        disabled
        style={{ maxWidth: "8rem" }}
        value={indicateur.valeurCalculee?.value ?? ""}
        label={t("hve3a.valeur-mesparcelles", "Valeur MesParcelles")}
        InputProps={valueInputProps}
        numberOfDecimals={2}
        className={"mr-2"}
      />
    );

    const valueRendered = (
      <NumberInput
        fullWidth={false}
        value={indicateur.valeur.value ?? ""}
        InputLabelProps={{
          style: { fontWeight: indicateur.afficherGras ? "bold" : "normal" },
        }}
        style={{ maxWidth: "8rem" }}
        InputProps={valueInputProps}
        disabled={computedFields.includes(indicateur.codeNational)}
        onChange={(newValeur) =>
          changeIndicateur(
            { ...indicateur, valeur: { value: newValeur === "" ? null : Number(newValeur) } },
            sousRubriqueIndex,
            libelleEnglobantIndex
          )
        }
        numberOfDecimals={2}
      />
    );

    return (
      <Indicator indicateur={indicateur} onChange={onChangeIndicator} demarche={demarche}>
        {!!indicateur.valeurCalculee && valeurCalculee}
        {valueRendered}
      </Indicator>
    );
  }
}

export default compose(withTranslation())(DecimalPositif);
